<template>
  <b-row>
    <b-col
      cols="12"
      md="6"
    >
      <b-overlay
        :show="isPending"
        rounded="sm"
      >
        <b-card>
          <validation-observer ref="simpleRules">
            <b-form @submit.prevent="validationForm">

              <b-form-group
                label="Icon"
                label-for="v-icon"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Icon"
                  rules="required"
                >
                  <form-image
                    v-model="form.icon"
                    label="Pilih Icon"
                    :state="errors.length > 0 ? false : null"
                    @finish="setIconFile"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Nama -->
              <b-form-group
                label="Nama"
                label-for="v-name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Nama"
                  rules="required"
                >
                  <b-form-input
                    id="v-name"
                    v-model="form.name"
                    :state="errors.length > 0 ? false : null"
                    @input="generateSlug"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Slug -->
              <b-form-group
                label="Slug"
                label-for="v-slug"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Slug"
                  rules="required"
                >
                  <b-form-input
                    id="v-slug"
                    v-model="form.slug"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Parent -->
              <b-form-group
                label="Parent"
                label-for="v-category"
              >
                <v-select
                  v-model="selectedCategory"
                  label="name"
                  :options="categoryList"
                >
                  <template #no-options="">
                    Kategori tidak ditemukan.
                  </template>
                </v-select>
              </b-form-group>

              <!-- Urutan -->
              <b-form-group
                label="Urutan"
                label-for="v-order"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Urutan"
                  rules="min_value:1|integer"
                >
                  <b-row>
                    <b-col
                      cols="6"
                      lg="5"
                      xl="4"
                    >
                      <b-form-input
                        id="v-order"
                        v-model="form.order"
                        type="number"
                        :state="errors.length > 0 ? false : null"
                      />
                    </b-col>
                  </b-row>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Deskripsi -->
              <b-form-group
                label="Artikel"
                label-for="v-article"
              >
                <quill-editor
                  id="v-article"
                  v-model="form.article"
                />
              </b-form-group>

              <!-- Button -->
              <div class="d-flex justify-content-end mt-3">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  :disabled="isSubmitting"
                >
                  <b-spinner
                    v-if="isSubmitting"
                    small
                  />
                  {{ isSubmitting ? "Menyimpan" : "Simpan" }}
                </b-button>
              </div>
            </b-form>
          </validation-observer>
        </b-card>
      </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BSpinner,
  BOverlay,
} from 'bootstrap-vue'

import FormImage from '@/layouts/components/custom/FormImage.vue'

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

// Quill Editor
// eslint-disable-next-line
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";
import { quillEditor } from 'vue-quill-editor'

// Vee Validate
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, integer, minValue } from '@validations'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BOverlay,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    FormImage,
    quillEditor,
  },
  directives: {
    Ripple,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        icon: '',
        iconFile: '',
        name: '',
        slug: '',
        parent_id: '',
        article: '',
        order: '',
      },
      urlPreview: '',
      selectedCategory: null,
      required,
      minValue,
      integer,
      isPending: false,
      isSubmitting: false,
    }
  },
  computed: {
    ...mapGetters('category', ['categoryList']),
    ...mapState('category', ['category']),
    categoryId() {
      if (this.isEdit) {
        return this.$route.params.id
      }
      return null
    },
  },
  async created() {
    this.isPending = true

    await this.getCategoryList()

    if (this.isEdit) {
      await this.getCategory({ id: this.categoryId })
      this.fillData()
    }

    this.isPending = false
  },
  methods: {
    ...mapActions('category', ['getCategoryList', 'createCategory', 'updateCategory', 'getCategory']),
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.handleSubmit()
        }
      })
    },
    setIconFile(file) {
      if (file) {
        this.form.iconFile = file
      }
    },
    async handleSubmit() {
      this.isSubmitting = true

      if (this.selectedCategory) {
        this.form.parent_id = this.selectedCategory.id
      }

      if (!this.isEdit) {
        await this.createCategory(this.form)
          .then(() => {
            this.$router.push('/categories')
          })
          .catch(() => {
            this.isSubmitting = false
          })
      } else {
        await this.updateCategory({ categoryId: this.categoryId, data: this.form })
          .then(() => {
            this.$router.push('/categories')
          })
          .catch(() => {
            this.isSubmitting = false
          })
      }
    },
    generateSlug(value) {
      this.form.slug = this.toSlug(value)
    },
    // Edit State Only
    fillData() {
      this.form.icon = this.linkStaging(this.category.data.image_url, 100, 100)
      this.form.name = this.category.data.name
      this.form.slug = this.category.data.slug
      this.form.article = this.category.data.article
      this.form.order = this.category.data.order

      if (this.category.data.parent_id) {
        const category = this.categoryList.find(c => c.id === this.category.data.parent_id)
        this.selectedCategory = { id: this.category.data.parent_id, name: category.name }
      }
    },
  },
}
</script>

<style lang="scss">
.image-preview {
    width: 102px;
    height: 102px;
    background-color: white;
    border: 1px solid red;
    position: relative;
    img {
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}
</style>
